<template lang="">
    <div class='contact-card'>
        <div v-if='icon_url' class='c-logo'>
            <img :src='icon_url'>
        </div>
        <div class='contact-title'>{{ title }}</div>
        <div class='contact-separator'></div>
        <div class='contact-list'>
            <div class='c-line' v-if='weburl'>
                <img class='c-icon' :src='web_icon_url'>
                <!-- <div class='c-sep'></div> -->
                <input :id='u_id+"_web"' class='s-inp' disabled :value='weburl'/>
                <img class='c-icon c-pt' :src='copy_icon_url'>
                <a :href='weburl' target='_blank'><img class='c-icon c-pt' :src='open_icon_url'></a>
            </div>
            <div class='c-line' v-if='tag'>
                <img class='c-icon' :src='at_icon_url'>
                <!-- <div class='c-sep'></div> -->
                <input :id='u_id+"_tag"' class='s-inp' disabled :value='tag'/>
                <img class='c-icon c-pt' @click='copy_me(u_id+"_tag")' :src='copy_icon_url'>
                <a :href='link_url' target='_blank'><img v-if='link_url' class='c-icon c-pt' :src='open_icon_url'></a>
            </div>
            <div class='c-line' v-if='note'>
                <img class='c-icon' :src='note_icon_url'>
                <!-- <div class='c-sep'></div> -->
                <p class='c-note'>{{note}}</p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'ContactCard',
    components: {},
    props:['data', 'icon'],
    setup(props) {

        const copy_icon_url = "https://www.svgrepo.com/show/505348/copy.svg"
        const open_icon_url = "https://www.svgrepo.com/show/489764/open-in-new-window.svg"
        const tag_icon_url = "https://www.svgrepo.com/show/533457/tag.svg"
        const at_icon_url = "https://www.svgrepo.com/show/533176/at-sign.svg"
        const link_icon_url = "https://www.svgrepo.com/show/532869/link-alt-1.svg"
        const note_icon_url = "https://www.svgrepo.com/show/533426/note-sticky.svg"
        const web_icon_url = "https://www.svgrepo.com/show/473990/web.svg"

        const u_id = Math.floor(Math.random()*65535)+""

        const title = props['data'].title || "Link"
        const icon_url = props['data'].icon
        const tag = props['data'].tag
        const link_url = props['data'].ln
        const note = props['data'].note
        const weburl = props['data'].weburl

        const copy_me = (id) => {
            let e = document.getElementById(id)
            if(!e){
                console.warn(`Copy source ID:${id} was not found`)
            }
            e.select();
            e.setSelectionRange(0,9999);
            navigator.clipboard.writeText(e.value);
        }
        
        return {
            title, icon_url, tag, link_url, weburl,
            note, copy_icon_url, open_icon_url,
            tag_icon_url, at_icon_url, link_icon_url,
            note_icon_url, u_id, copy_me, web_icon_url
        }
    },
}
</script>
<style>
    .contact-card{
        display: flex;
        align-items: center;
        flex-direction: column;
        border: solid white 0.14em;
        border-radius: 1em;
        padding: 1em;
        overflow: hidden;
        position: relative;
        max-width: 15em;
        transition: filter 200ms;
        backdrop-filter: brightness(0.7) blur(0.2em)
    }

    .contact-card:hover{
        filter: drop-shadow(0px 0px 0.4em #FFFFFF90);
    }

    .contact-card:hover .c-logo{
        transform: translate(0, -25%) scale(1.1)
    }

    .contact-title{
        font-size: 1.3em;
        font-weight: 800;
        margin-bottom: 0.7em;
    }

    .c-icon{
        width: 1.5em;
        margin-inline: 0.2em;
        filter: invert(1) brightness(100);
        -webkit-filter: invert(1) brightness(100);
    }

    .c-logo{
        filter: invert(1) brightness(100);
        -webkit-filter: invert(1) brightness(100);
        opacity: 0.15;
        z-index:-1;
        position: absolute;
        display: flex;
        align-content: center;
        align-items: center;
        justify-content: center;
        transform: translate(0, -30%);
        transition: transform 200ms cubic-bezier(0,.98,.76,.64);
    }

    .c-pt{
        cursor: pointer;
        transition: filter 200ms, transform 200ms;
    }

    .c-pt:hover{
        transform: scale(1.05);
        filter: invert(1) brightness(100) drop-shadow(0px 0px 0.4em #FFFFFFf0);
    }
    
    .c-pt:active{
        transform: scale(0.95);
    }

    .c-logo img{
        width: 50%;
    }

    .c-line{
        display: flex;
        flex-direction:row;
        align-items: center;
        align-content: center;
        margin-bottom: 0.4em;
    }

    .c-line input, input:disabled, textarea{
        outline: none;
        background: transparent;
        border: dashed white 1px;
        color: #FCFCFC;
        font-family: "Ubuntu Mono", monospace;
        padding: 0.2em 0.4em;
    }
</style>